import "./Error.css";

const Error = () => {
  return (
    <section className="error-page">
        <p>Something went wrong</p>
    </section>
  );
};

export default Error;
